import jwt from "jsonwebtoken"
import moment, { unitOfTime } from "moment"
import { LocalStorageService } from "Shared/services"
import { ACCESS_TOKEN } from "Shared/services/localstorage.service"

export const getAccessTokenValidTime = (unit: unitOfTime.Diff = "seconds") => {
    const accessTokenEncoded = LocalStorageService.get(ACCESS_TOKEN)
    if (!accessTokenEncoded) throw new Error("AccessToken missing")

    const accessToken = jwt.decode(accessTokenEncoded) as { [key: string]: string }
    const time = moment(Number(accessToken.exp) * 1000)
    const dif = time.diff(moment(), unit)
    return dif
}
